/**
 * Global "new note" FAB rendered by the root layout.
 *
 * Previously the FAB lived inside NotesGrid, which meant it vanished on
 * routes that don't render the grid (notably /search). Lifting it here gives
 * a consistent affordance everywhere — including search, which is exactly
 * the place where "I found nothing, let me jot something down" is most
 * useful. The click delegates to triggerNewNote, the same helper the `c`
 * keyboard shortcut uses: if a grid is mounted it creates inline, otherwise
 * we navigate home first.
 */

import { Plus } from "lucide-react";
import { useNavigate, useRouterState } from "@tanstack/react-router";
import { triggerNewNote } from "../lib/shortcuts";

export function NewNoteFab() {
  const navigate = useNavigate();
  const path = useRouterState({ select: (s) => s.location.pathname });

  // Trash is the one place where creating a new note from here would be
  // confusing (you'd land in /trash and not see the note appear).
  if (path === "/trash") return null;

  return (
    <button
      type="button"
      onClick={() => triggerNewNote(navigate, path)}
      className="fab"
      aria-label="New note"
      title="New note (c)"
    >
      <Plus className="w-6 h-6" />
    </button>
  );
}
